<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRange }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="forms.tranDateFrom"
                            :error-messages="errors.collect('forms.tranDateFrom')"
                            v-validate="tranDateFromValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="forms.tranDateTo"
                            :error-messages="errors.collect('forms.tranDateTo')"
                            v-validate="tranDateToValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.acctNo"
                            :label="labels.acctNo"
                            :error-messages="errors.collect('forms.acctNo')"
                            data-vv-name="forms.acctNo"
                            :data-vv-as="labels.acctNo"
                            append-icon="mdi-magnify"
                            @click:append="getAcctNoHelpList()"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-radio-group v-model="forms.isIncludePolNos" :mandatory="true" @change="doIncExcPolNos($event)">
                            <v-radio :label="labels.includePolNos" :value="true"></v-radio>
                            <v-radio :label="labels.excludePolNos" :value="false"></v-radio>
                          </v-radio-group>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            readonly
                            v-model="forms.polNo"
                            :label="labels.polNo"
                            :error-messages="errors.collect('forms.polNo')"
                            data-vv-name="forms.polNo"
                            :data-vv-as="labels.polNo"
                            append-icon="mdi-magnify"
                            @click:append="getPolNoHelpList()"
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-divider></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-checkbox
                            :label="labels.includePolZeroPrem"
                            v-model="forms.isIncludePolZeroPrem"
                            @change="doIncludePolZeroPrem($event)"
                          ></v-checkbox>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12 v-if="forms.isIncludePolZeroPrem">
                          <v-autocomplete
                            multiple
                            :items="excludePremHdgList"
                            v-model="forms.excludePremHdg"
                            :label="labels.excludePremHdg"
                            item-text="label"
                            item-value="value"
                            data-vv-name="forms.excludePremHdg"
                            :data-vv-as="labels.excludePremHdg"
                            :error-messages="errors.collect('forms.excludePremHdg')"
                            v-validate="excludePremHdgValidation"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-flex xs12 sm12 md12 lg12 class="pt-3">
            <v-btn color="primary" type="submit" :loading="loading" @click.prevent="doSubmit" class="mr-2">
              <v-icon left dark>mdi-file-export</v-icon>
              {{ labels.export }}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="forms.format">
              <v-btn text>
                <span>{{ labels.format }}</span>
                <v-icon>mdi-file-document</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-flex>
        <v-dialog v-model="acctNoList" width="900px" persistent>
          <AcctNoUOBHelpList v-if="acctNoList" @close="doClose" @doAssign="doAssignAcctNo($event)"></AcctNoUOBHelpList>
        </v-dialog>
        <v-dialog v-model="polNoList" width="900px" persistent>
          <multi-polNo-help-list2 :tranRel="true" :polno="forms.polNo" @close="doClose" @doAssign="doAssign($event)"></multi-polNo-help-list2>
          <!-- <multi-polNo-help-list :polnos="forms.polNo" :apiUrl="relPolNoApiUrl" @close="doClose" @doAssign="doAssignPolNo($event)"></multi-polNo-help-list> -->
        </v-dialog>
      </v-layout>
    </v-container>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { expandURI } from '@/utils/ajax'
import AcctNoUOBHelpList from './helplist/AcctNoUOBHelpList'
import MultiPolNoHelpList2 from '@/components/core/common/dialog/MultiPolNoHelpList2'
import { excludePremHdg } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Selection Criteria',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        filters: 'Filters',
        acctNo: 'Account No.',
        includePolNos: 'Include selected policy No.',
        excludePolNos: 'Exclude selected policy No.',
        polNo: 'Policy No.',
        includePolZeroPrem: 'Include Policies with Zero Premium',
        excludePremHdg: 'Exclude Premium Heading',
        export: 'Export To',
        format: 'ASCII TEXT'
      },
      forms: {
        tranDateFrom: null,
        tranDateTo: null,
        acctNo: 'All',
        polNo: 'All',
        isIncludePolNos: true,
        isIncludePolZeroPrem: false,
        excludePremHdg: ''
      },
      acctNoList: false,
      polNoList: false,
      loading: false,
      supportedList: [
        {
          label: 'ASCII TEXT',
          value: 'ASCII TEXT'
        }
      ],
      showErrorDialog: false,
      relPolNoApiUrl: '',
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    tranDateFromValidation() {
      if (this.forms.tranDateFrom !== '' && this.forms.tranDateFrom !== null && this.forms.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.forms.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.forms.tranDateTo !== '' && this.forms.tranDateTo !== null && this.forms.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.forms.tranDateFrom
      } else {
        return 'required'
      }
    },
    excludePremHdgValidation() {
      if (this.forms.isIncludePolZeroPrem && this.forms.excludePremHdg === '') {
        return 'required'
      } else {
        return null
      }
    },
    displayErrorDialog() {
      return this.messages
    },
    excludePremHdgList() {
      let result = []
      Object.keys(excludePremHdg).forEach(function (key) {
        const status = excludePremHdg[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doInit() {},
    getAcctNoHelpList() {
      this.acctNoList = true
      this.polNoList = false
    },
    getPolNoHelpList() {
      this.acctNoList = false
      this.polNoList = true
    },
    doIncExcPolNos(data) {
      if (data) {
        this.forms.polNo = 'All'
      } else {
        this.forms.polNo = 'None'
      }
      this.forms.isIncludePolNos = data
    },
    doIncludePolZeroPrem(data) {
      if (!data) {
        this.forms.excludePremHdg = ''
      }
      this.forms.isIncludePolZeroPrem = data
    },
    doClose() {
      this.acctNoList = false
      this.polNoList = false
    },
    async doAssignAcctNo(Obj) {
      this.forms.acctNo = []
      this.forms.acctNo = Obj.finalSelectedItems.toString()
    },
    async doAssign(Obj) {
      this.forms.polNo = []
      this.forms.polNo = Obj.finalSelectedItems.toString()
    },
    // async doAssignPolNo(Obj) {
    //   this.forms.polNo = []
    //   this.forms.polNo = Obj.finalSelectedItems.toString()
    // },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doExport() {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.exportUOBProposal
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            tranDateFrom: this.forms.tranDateFrom,
            tranDateTo: this.forms.tranDateTo,
            acctNo: this.forms.acctNo,
            polNo: this.forms.polNo,
            isIncludePolNos: this.forms.isIncludePolNos,
            isIncludePolZeroPrem: this.forms.isIncludePolZeroPrem,
            excludePremHdg: this.forms.excludePremHdg
          }
          await this.$http.post(expandURI(apiUrl, expand))
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })

    // this.relPolNoApiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.relPolNoList
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    AcctNoUOBHelpList,
    MultiPolNoHelpList2
  }
}
</script>

<style>
</style>
